import GSAP from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { hideOnClickOutside } from "../utils/utils";

GSAP.registerPlugin(ScrollTrigger)

export default class Nav {
	constructor() {
		this.nav 			= document.querySelector('.nav');
		this.triggers 		= document.querySelectorAll('[data-menu="main"]');
		this.sidebar		= document.querySelector('.nav__sidebar');
		this.init			= this.init.bind(this)
		this.toggleSidebar	= this.toggleSidebar.bind(this)
			
		this.init()
		this.sticky()
		
	}
	init()
	{
		this.triggers && this.triggers.forEach((trigger) => {
			trigger.addEventListener('click', (event) => {
				event.preventDefault();
				this.toggleSidebar()
			});
		})
	}
	toggleSidebar()
	{
		document.querySelector('body').classList.toggle('nav--open');

		window.app.smoothScroll.lenis && window.app.smoothScroll.lenis.isStopped ? window.app.smoothScroll.lenis.start() : window.app.smoothScroll.lenis.stop()

		hideOnClickOutside( this.sidebar, 'nav--open', null, 'btn-dropdown' )
	}
	sticky()
	{

		// HIDING NAV ON SCROLL USING GSAP

		this.showNavAnimation = GSAP.from(this.nav, { 
			y: '-72px',
			paused: true,
			duration: 0.1
		}).progress(1);
		
		this.scrollHideStartDistance = '100px top'

		ScrollTrigger.create({
			start: this.scrollHideStartDistance,
			end: 'max',
			onUpdate: (self) => {
				if( self.direction === -1 ){
					this.showNavAnimation.play()
				} else {
					this.showNavAnimation.reverse()
				}
			}
		});

	}
}
